module.exports = __webpack_public_path__ + "img/SCC_TMKI67.d1589fcc.png";